// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Kn_6","buttons":"PendingPaymentAlert_buttons__hf2Zx"};